import { humanizeList } from '@craft/lib/formatters';

import { logger } from '../logger';

export enum Platform {
  Android = 'Android',
  Mac = 'Mac',
  Other = 'Other',
  Windows = 'Windows',
}

export const PlatformData = {
  [Platform.Android]: {
    platformRegex: /Android/i,
  },
  [Platform.Mac]: {
    platformRegex: /(Mac|iP(hone|od|ad))/i,
  },
  [Platform.Windows]: {
    platformRegex: /Windows/i,
  },
} as const satisfies Record<Exclude<Platform, Platform.Other>, { readonly platformRegex: RegExp }>;

export const getPlatform = () => {
  if (typeof window === 'undefined') {
    throw new Error('This method can only be used on the client!');
  }
  const discoveredPlatforms: Platform[] = [];
  for (const platform of Object.values(Platform).filter(plat => plat !== Platform.Other)) {
    const { platformRegex } = PlatformData[platform];
    if (platformRegex.test(navigator.platform)) {
      discoveredPlatforms.push(platform);
    }
  }
  if (discoveredPlatforms.length === 0) {
    return Platform.Other;
  }
  if (discoveredPlatforms.length > 1) {
    const humanizedPlatforms = humanizeList(discoveredPlatforms, {
      conjunction: 'and',
      formatter: v => `'${v}'`,
    });
    logger.error(
      `Encountered multiple platforms, ${humanizedPlatforms}, for the current user agent!`,
    );
  }
  return discoveredPlatforms[0];
};

export const isMacPlatform = () => getPlatform() === Platform.Mac;

export const isWindowsPlatform = () => getPlatform() === Platform.Windows;

export const isAndroidPlatform = () => getPlatform() === Platform.Android;

export const isUnknownPlatform = () => getPlatform() === Platform.Android;
